export default Object.freeze({
    enabled: 'enabled',
    select: 'select',
    flatSelect: 'flat-select',
})
